import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { ExcelService } from 'app/misc/excel.service';
import { BulkPayService } from 'app/modules/bulk-pay/bulk-pay.service';
import { CategoryRecipientsComponent } from 'app/modules/bulk-pay/category-recipients/category-recipients.component';
import { Country, Recipient } from 'app/modules/bulk-pay/_state/bulk-pay.interfaces';
import { MerchantWallet } from 'app/modules/products/_state/products.interfaces';
import { AppState, selectPendingTransactions, selectPendingTransactionsError, selectPendingTransactionsLoading } from 'app/reducers';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as dashboardActions from '../../dashboard/_state/dashboard.actions'
import * as bulkPayActions from '../../bulk-pay/_state/bulk-pay.actions'
import * as transactionsActions from '../../transactions/_state/txn.actions'
import { TransactionsService } from 'app/modules/transactions/transactions.service';
import { AuthorizerService } from 'app/modules/authorizers/authorizers.service';
import { MerchantTransactionsService } from 'app/modules/merchant-transactions/merchant-transactions.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pending-bulk-pay-transactions',
  templateUrl: './pending-bulk-pay-transactions.component.html',
  styleUrls: ['./pending-bulk-pay-transactions.component.css']
})
export class PendingBulkPayTransactionsComponent extends CategoryRecipientsComponent implements OnInit {

  constructor(
    protected store: Store<AppState>,
    protected actions$: Actions,
    protected router: Router,
    protected toastr: ToastrService,
    protected route: ActivatedRoute,
    public miscService: MiscService,
    protected bulkpayService: BulkPayService,
    protected excelService : ExcelService,
    public transactionService: TransactionsService,
    protected authorizerService: AuthorizerService,
    private merchantTransactionsService: MerchantTransactionsService,
  ) {
    super(store,actions$,router,toastr,route,miscService,bulkpayService, excelService, authorizerService)
  }
  isRecipients: boolean;
  selectedRecipients: Recipient[];
  protected unsubscribe$ = new Subject<void>();
  ezremitForm: FormGroup = new FormGroup({});
  ezremitTransferModes: any[] = [];
  ezremitBranches: any[] = [];
  ezremitFundSources: any[] = [];
  ezremitFundPurposes: any[] = [];
  ezremitRelationships: any[] = [];
  isLoadingEZremitDropdowns: boolean = false;
  isLoadingTransferModeFields: boolean = false;
  private ezremitParams: any = null;
  papssFeesMap: { [index: number]: number | null } = {};
  loadingPapssFeesMap: { [index: number]: boolean } = {};
  pendingBulkPayTransactions$ = this.store.pipe(select(selectPendingTransactions))
  pendingBulkPayTransactionsLoading$ = this.store.pipe(select(selectPendingTransactionsLoading))
  pendingBulkPayTransactionsError$ = this.store.pipe(select(selectPendingTransactionsError))
  selectedTransaction: any;
  isSendingAuthorization: boolean;
  isDeleting: boolean;
  deleteModalOpen: boolean;
  pageIndex: number = 1; // Mat-paginator uses 0-based indexing
  pageSize: number = 20;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 20, 50, 100, 300, 500];
  showFirstLastButtons: boolean = true;

  paymentStatusModalOpen = false;
  paymentStatus: 'success' | 'pending' | 'failed' | null = null;
  paymentStatusMessages: string[] = [];

  makePayment(payee: Recipient, payload) {
    const finalPayload = payee['is_papss']
      ? { ...payload, is_papss: true, papss_direction: 'outbound' }
      : payload;

    this.bulkPayInProcess = true;
    this.bulkpayService.payRecipient(finalPayload, payee.scheme_code).subscribe(
      res => {
        this.transactionsDone++;
        if (res['data']['code'] == '00') {
          this.toastr.success(`Payment to ${payee.name} successful`);
          this.paymentStatusMessages.push(`Payment to ${payee.name} was successful.`);
          if (this.paymentStatus !== 'failed' && this.paymentStatus !== 'pending') {
            this.paymentStatus = 'success';
          }
          if (this.paymentList.length === this.transactionsDone) {
            this.updateTransactionStatus([], '3');
          }
        } else if (res['data']['code'] == '31') {
          this.toastr.info(`Payment to ${payee.name} is pending`, res['data']['message']['en']);
          this.paymentStatusMessages.push(`Payment to ${payee.name} is pending.`);
          if (this.paymentStatus !== 'failed') {
            this.paymentStatus = 'pending';
          }
        } else {
          this.failedToPay.push({ product_id: payee.product_id });
          this.toastr.error(res['data']['message']?.['en'] || 'Unknown error', `Payment to ${payee.name} failed`);
          this.paymentStatusMessages.push(res['data']['message']?.['en'] || 'Unknown error');
          this.paymentStatus = 'failed';
        }
        if (this.paymentList.length === this.transactionsDone) {
          this._finishPayment();
        }
      },
      err => {
        this.transactionsDone++;
        this.failedToPay.push({ product_id: payee.product_id });
        this.toastr.error(err.error?.message || err.error?.errors || 'An error occurred', `Payment to ${payee.name} failed`);
        this.paymentStatusMessages.push(err.error?.message || err.error?.errors || 'An error occurred');
        this.paymentStatus = 'failed';
        if (this.paymentList.length === this.transactionsDone) {
          this._finishPayment();
        }
      }
    );
  }

  onCheckSignaturesSuccessful = () => {
    this.actions$.pipe(
      ofType(transactionsActions.checkSignaturesSuccess),
      takeUntil(this.unsubscribe$)
    ).subscribe((response: any) => {
      this.checkingSignatures = false;
      if (!response.signaturesResult.success) {
        this.toastr.info(response.signaturesResult?.message || response.message || 'Awaiting pending authorization approval', 'Info');
      } else {
        this.togglePaymentModal('close');
        this.sendOTP();
        this.toggleOtpModal('open');
      }
    });
  }

  private _finishPayment() {
    this.toggleOtpModal('close');
    this.bulkPayInProcess = false;
    this.otpForm.reset();
    this.paymentForm.reset();
    this.isPaymentPage = null;
    this.isNotifying = null;
    this.checkingSignatures = null;
    this.authorizersNotifed = null;
    this.sufficientBalance = null;
    this.paymentList = [];
    this.transactionsDone = 0;
    this.paymentStatusModalOpen = true;
  }

  closePaymentStatusModal() {
    this.paymentStatusModalOpen = false;
    this.paymentStatus = null;
    this.paymentStatusMessages = [];
    this.router.navigate(['/app/make-payment/transactions/all']);
  }

  ngOnInit(): void {
    this.fetchPendingBulkPayTransactions();
    this.authorizersNotifed = true;
    this.paymentForm = new FormGroup({
      description: new FormControl(''),
      walletToDebit: new FormControl('', Validators.required)
    })
    this.otpForm = new FormGroup({
      otp: new FormControl('', Validators.required)
    })
    this.kycForm = new FormGroup({
      sender_first_name: new FormControl('', Validators.required),
      sender_last_name: new FormControl('', Validators.required),
      sender_nationality: new FormControl(this.miscService.getMerchantDetails()?.currency?.iso_code_2 || '', Validators.required),
      sender_birthdate: new FormControl('', Validators.required),
      sender_city: new FormControl('', Validators.required),
      sender_address: new FormControl('', Validators.required),
      sender_permanent_address: new FormControl('', Validators.required),
      sender_occupation: new FormControl('', Validators.required),
      identity_number: new FormControl('', Validators.required),
      document_issue_date: new FormControl('', Validators.required),
      document_expiration_date: new FormControl('', Validators.required),
    })
    this.countries$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: Country[]) => this.countries = res);
    this.wallets$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: MerchantWallet[]) => this.wallets = res)
    this.fetchCountries();
    this.fetchMerchantWallets();
    this.onFetchBalanceSuccessful();
    this.onCheckSignaturesSuccessful();
    this.onCheckSignaturesFailed();
    this.onSendOTPSuccessful();
    this.onUpdateTransactionStatusFailed();
    this.onUpdateTransactionStatusSuccessful();

      this.pendingBulkPayTransactions$.subscribe(data => {
      if (data) {
        this.totalItems = data.totalCount || data.data?.totalCount || 0;
        this.pageIndex = (data.page || data.data?.page || 1) - 1;
        this.pageSize = data.limit || data.data?.limit || 10;
      }
    });
  }
  getCountry = (code) => this.countries.find(country => code === country?.alpha2Code)?.currencyCode
    // API CALLS
    fetchPendingBulkPayTransactions = () => {
      this.store.dispatch(dashboardActions.fetchPendingTransactions({
            txnId: 'bulkpay',
            page: this.pageIndex,
            limit: this.pageSize
          }));
    }

      handlePageEvent = (event: PageEvent) => {
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.fetchPendingBulkPayTransactions();
      }

    // getDlCodes = () => {
    //   this.bulkPayInProcess = true;
    //   this.paymentList.map(payee => {
    //     let requestPayload;
    //     let payeeCountry = this.countries.find(country => payee.country_code === country.callingCode).alpha2Code
    //     if(payeeCountry == 'GB'){
    //        requestPayload = {
    //         config_preset: 'SgKOr2mJp',
    //         transaction_params: {
    //           payeeId: payee.card_num? payee.card_num : payee['bank_sort_code'] + payee['bank_account_no'],
    //           payerId: this.selectedWallet.account_id,
    //           src_amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //           des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //         }
    //       }
    //     } else {
    //       requestPayload = {
    //         config_preset: 'SgKOr2mJp',
    //         transaction_params: {
    //           payeeId: payee.card_num? payee.card_num : payee['bank_code'] + payee['bank_account_no'],
    //           payerId: this.selectedWallet.account_id,
    //           src_amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //           des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //         }
    //       }
    //     }
    //     this.bulkpayService.generateDLCode(requestPayload).subscribe(
    //       res => {
    //         this.makePayment(payee, res['otp_sid'])
    //       },
    //       err => {
    //         this.bulkPayInProcess = false;
    //         this.toastr.error(`Payment was not completed for ${payee.name}`,'Transaction failed');
    //         this.failedToPay.push({product_id: payee.product_id})
    //       } 
    //       )
    //     })
        
    //   }
    //   generatePaymentReference() {
    //     const currentDate = new Date();
    //     const formattedDate = currentDate.toISOString().replace(/[-:.TZ]/g, '').replace(/\s/g, '');
    //     const reference = `CUD${formattedDate}` + (Math.ceil(Math.random() * 10e13)).toString();
    //     return reference;
    //   }
    //   makePayment = (payee: Recipient, dl_code) => {
    //     this.bulkPayInProcess = true;
    //     let requestBody;
    //     let payeeCountry = this.countries.find(country => payee.country_code === country.callingCode).alpha2Code
    //     requestBody = {
    //       otp_sid: this.otpSid,
    //       description: this.paymentForm.get('description').value,
    //       channel_id: "XCelBusiness",
    //       currency: this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //       account_id: this.selectedWallet.account_id || '',
    //       src_scheme: this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //       des_card_num: payee.card_num || payee['bank_account_no'],
    //       src_country: this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //       to_provider_code: payee['bank_code'] || '',
    //       type: payee.payment_type == 'Account'? 'bank' : payee.payment_type == 'momo'? 'momo' : 'wallet',
    //       amount: this.miscService.formatTo2DecimalPlaces(payee.amount),
    //       rate: this.countries.find(country => payee.country_code === country.callingCode).alpha2Code == this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code ? '1' : payee.rate,
    //       dest_country: this.countries.find(country => payee.country_code === country.callingCode).alpha2Code ,
    //       account_name: payee.name,
    //       des_currency: this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //       sortCode: payee['bank_sort_code']|| '',
    //       OTP: this.otpForm.get('otp').value,
    //       des_amount: this.miscService.formatTo2DecimalPlaces(payee.des_amount || payee.amount),
    //       merchant: false,
    //       dest_scheme: payee.scheme_code,
    //       dl_code
    //   }
    //     // if(payeeCountry == 'GB'){
    //     //   requestBody ={
    //     //     "amount": this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "account_no": payee.wallet? payee.wallet: payee['bank_account_no'],
    //     //     "name": payee.name,
    //     //     "OTP": this.otpForm.get('otp').value,
    //     //     "fees_paid":"0.00",
    //     //     "sortCode": payee['bank_sort_code']|| '',
    //     //     "src_scheme": this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //     //     "ref_no": this.currentPaymentId,
    //     //     "bank_code": payee['bank_code'] || '',
    //     //     "reference": this.currentPaymentId,
    //     //     "interbank": payee.bank ? this.selectedWallet.sortCode == payee['bank_sort_code']? true : false : true,
    //     //     "merchant": false,
    //     //     "otp_sid": this.otpSid,
    //     //     "auth":"",
    //     //     "src_country":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //     //     "international":payee.scheme_code === this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004'? false: true,
    //     //     "src_card_num":this.selectedWallet.account_id,
    //     //     "dest_scheme":payee.scheme_code,
    //     //     "description":this.paymentForm.get('description').value,
    //     //     "org_code":"0000",
    //     //     "id_code":"0000000000",
    //     //     "des_amount": this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "sub_issuer_code":"0000",
    //     //     "currency":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //     //     "date": new Date().toISOString(),
    //     //     "secureInstallationId":"",
    //     //     "external_reference": this.generatePaymentReference(),
    //     //     // "external_reference": 'CUD' + new Date().toISOString().split('.')[0], //check if it's not meant to be same value as source wallet number
    //     //     "due_fees":{
    //     //        "vat":"0.0",
    //     //        "stamp":"0.0",
    //     //        "transaction":0.00
    //     //     },
    //     //     "src_person":this.miscService.getMerchantDetails().reg_name,
    //     //     "dest_person":payee.name,
    //     //     "dl_code":dl_code,
    //     //     "dest_wallet_no": payee.wallet || '',
    //     //     "account_id": this.selectedWallet.account_id || '', //src or des
    //     //     "destinationAccountId":payee.card_num || '',
    //     //     "merchant_fees":"0",
    //     //     "channel_id":"XCelBusiness",
    //     //     "fees":false,
    //     //     "type": payee.payment_type == 'Account'? 'Bank' : 'Wallet',
    //     //     "accountNumber": payee.wallet || payee['bank_account_no'],
    //     //     "dest_country":this.countries.find(country => payee.country_code === country.callingCode).alpha2Code,
    //     //     "sourceAccountId": this.selectedWallet.account_id || '',
    //     //     "issuer_code":"0000",
    //     //     "des_card_num": payee.card_num,
    //     //     "src_wallet_no":this.selectedWallet.account_number,
    //     //     "pin":"1234",
    //     //     "des_currency":this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //     //     "org_br_code":"0000"
    //     //  }
    //     // }
    //     // else{
    //     //   requestBody = {
    //     //     "fees_paid":"0.00",
    //     //     "fees":false,
    //     //     "issuer_code":"0000",
    //     //     "id_code":"0000000000",
    //     //     "src_card_num":this.selectedWallet.account_id,
    //     //     "pin":"1234",
    //     //     "otp_sid": this.otpSid,
    //     //     "src_person":this.miscService.getMerchantDetails().reg_name,
    //     //     "date":new Date().toISOString(),
    //     //     "org_code":"0000",
    //     //     "description":this.paymentForm.get('description').value,
    //     //     "channel_id":"XCelBusiness",
    //     //     "reference": this.currentPaymentId,
    //     //     "interbank": payee.wallet? true: false,
    //     //     "currency":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).currencyCode,
    //     //     "merchant_fees":"0",
    //     //     "account_id": this.selectedWallet.account_id || '',
    //     //     "bank_code": payee['bank_code'] || '',
    //     //     "sub_issuer_code":"0000",
    //     //     "dest_person":payee.name,
    //     //     "src_scheme":this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004',
    //     //     "due_fees":{
    //     //        "stamp":"0.0",
    //     //        "vat":"0.0",
    //     //        "transaction":0.0
    //     //     },
    //     //     "des_card_num":payee.card_num,
    //     //     "src_country":this.countries.find(country => this.miscService.getMerchantDetails().country_code === country.callingCode).alpha2Code,
    //     //     "type":payee.payment_type == 'Account'? 'Bank' : 'Wallet',
    //     //     "amount":this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "name":payee.name,
    //     //     "account_no":payee.wallet? payee.wallet: payee['bank_account_no'],
    //     //     "dest_country":this.countries.find(country => payee.country_code === country.callingCode).alpha2Code,
    //     //     "des_currency":this.countries.find(country => payee.country_code === country.callingCode).currencyCode,
    //     //     "external_reference": this.generatePaymentReference(),
    //     //     // "external_reference":'CUD' + new Date().toISOString().split('.')[0], //check if it's not meant to be same value as source wallet number
    //     //     "secureInstallationId":"",
    //     //     "sourceAccountId":this.selectedWallet.account_id || '',
    //     //     "org_br_code":"0000",
    //     //     "sortCode": payee['bank_sort_code']|| '',
    //     //     "ref_no":this.currentPaymentId,
    //     //     "src_wallet_no":this.selectedWallet.account_number,
    //     //     "international":payee.scheme_code === this.miscService.formatCountryCode(this.miscService.getMerchantDetails().country_code) + '004'? false: true,
    //     //     "OTP":this.otpForm.get('otp').value,
    //     //     "des_amount":this.miscService.formatTo2DecimalPlaces(payee.amount),
    //     //     "merchant":false,
    //     //     "destinationAccountId":payee.card_num || '',
    //     //     "accountNumber":payee.wallet || payee['bank_account_no'],
    //     //     "dest_scheme":payee.scheme_code,
    //     //     "dl_code":dl_code,
    //     //     "auth":"",
    //     //     "dest_wallet_no":payee.wallet || ''
    //     //  }
    //     // }

    //     this.bulkpayService.payRecipient(requestBody, payee.scheme_code).subscribe(
    //       res => {
    //         this.transactionsDone++
    //         this.toastr.success(`Payment to ${payee.name} successful`);
    //         if(this.paymentList.length === this.transactionsDone){
    //           if(this.failedToPay.length === this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '1');
    //           else if(this.failedToPay.length > 0 && this.failedToPay.length < this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '2');
    //           else if(this.failedToPay.length == 0)
    //             this.updateTransactionStatus( [], '0');
    //           this.toggleOtpModal('close');
    //           this.bulkPayInProcess = false;
    //           this.otpForm.reset();
    //           this.paymentForm.reset();
    //           this.isPaymentPage = null;
    //           this.isNotifying = null;
    //           this.checkingSignatures = null;
    //           this.authorizersNotifed = null;
    //           this.sufficientBalance = null;
    //           this.paymentList = [];
    //           this.toastr.info('Bulk pay completed');
    //           this.fetchPendingBulkPayTransactions();
    //           this.goBack();
    //         }
    //       },
    //       err => {
    //         this.transactionsDone++
    //         this.failedToPay.push({product_id: payee.product_id})
    //         this.toastr.error(`Payment was not completed for ${payee.name}`,err.error.errors);
    //         if(this.paymentList.length === this.transactionsDone){
    //           if(this.failedToPay.length === this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '1');
    //           else if(this.failedToPay.length > 0 && this.failedToPay.length < this.paymentList.length)
    //             this.updateTransactionStatus( {failed_recipients:this.failedToPay}, '2');
    //           this.toggleOtpModal('close');
    //           this.bulkPayInProcess = false;
    //           this.otpForm.reset();
    //           this.paymentForm.reset();
    //           this.isPaymentPage = null;
    //           this.isNotifying = null;
    //           this.checkingSignatures = null;
    //           this.authorizersNotifed = null;
    //           this.sufficientBalance = null;
    //           this.paymentList = [];
    //           this.fetchPendingBulkPayTransactions();
    //           this.goBack();
    //           this.toastr.info('Check for pending or failed transactions','Bulk pay completed');
    //         }
    //       }
    //   )
    // }

    onUpdateTransactionStatusSuccessful = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.updateTransactionStatusSuccess),
        takeUntil(this.unsubscribe$)
      ).subscribe(response => {
        this.isUpdatingTransaction = false;
        this.isUpdatingTransactionFailed = false;
        if(this.router.url == '/app/bulk-pay/pending'){
          if(this.status == 'unfinished'){
            this.router.navigate(['/app/bulk-pay/unfinished'])
          } else if(this.status == 'successful' ){
            this.router.navigate(['/app/bulk-pay/successful'])
          } else if (this.status == 'failed'){
            this.router.navigate(['/app/bulk-pay/failed'])
          }
        } else if(this.router.url == '/app/make-payment/transactions/pending'){
         if(this.status == 'successful' ){
            this.router.navigate(['/app/make-payment/transactions/success'])
          } else if (this.status == 'failed'){
            this.router.navigate(['/app/make-payment/transactions/failed'])
          }
        }
      })
    }
    onUpdateTransactionStatusFailed = () => {
      this.actions$.pipe(
        ofType(bulkPayActions.updateTransactionStatusFailed),
        takeUntil(this.unsubscribe$)
        ).subscribe(response => {
          this.isUpdatingTransaction = false;
          this.isUpdatingTransactionFailed = true;
      })
    }
  
    //Template Interactions
    goBack = () => {
      this.isRecipients = false; 
      this.isPaymentPage = false; 
      this.selectedRecipients = []; 
    }
    selectForProcessing = (transaction) => {
      this.paymentForm.get('walletToDebit').setValue(transaction['src_wallet_number'])
      this.selectWallet({target:{value:this.paymentForm.get('walletToDebit').value}})
      this.fetchAccountBalance()
      this.selectedRecipients = transaction.recipients
      this.currentPaymentId = transaction.reference_id
      this.paymentList = this.selectedRecipients;
      this.totalToPay = this.paymentList.reduce(( sum:any, payee:any) => sum + parseFloat(payee.amount),0)
      const descCtrl = this.paymentForm.get('description');
      descCtrl.setValidators(Validators.required);
      if (transaction.description) {
        descCtrl.setValue(transaction.description);
        descCtrl.disable();
      } else {
        descCtrl.setValue('');
        descCtrl.enable();
      }
      descCtrl.updateValueAndValidity();
      this.isPaymentPage = true;
      this.isRecipients = true;
      this.fetchPapssFeesForRecipients();
      this.setupEZremitForm();
    }

    get totalPapssFee(): number {
      return Object.values(this.papssFeesMap).reduce((sum: number, fee: number | null) => sum + (fee || 0), 0);
    }

    get hasPapssRecipients(): boolean {
      return this.paymentList?.some((p: any) => p.is_papss) || false;
    }

  get hasCDRecipients(): boolean {
    return this.paymentList?.some(p => p.country_code === 'CD') ?? false;
  }

  get hasEZremitRecipients(): boolean {
    return this.paymentList?.some(p => ['IN', 'AE', 'CN'].includes(p.country_code)) ?? false;
  }

  setupEZremitForm = () => {
    const recipient: any = this.paymentList.find(p => ['IN', 'AE', 'CN'].includes(p.country_code));
    if (!recipient) return;

    const nameParts = (recipient.name || '').trim().split(' ');
    const merchantCountry = this.miscService.getMerchantDetails().currency.iso_code_2 || '';

    this.ezremitForm = new FormGroup({
      initiator: new FormGroup({
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        address: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        region: new FormControl(''),
        post_code: new FormControl(''),
        post_box: new FormControl(''),
        email: new FormControl('', Validators.required),
        phone_number: new FormControl('', Validators.required),
        dob: new FormControl('', Validators.required),
        id_number: new FormControl('', Validators.required),
        id_expiry_date: new FormControl('', Validators.required),
        document_type: new FormControl('', Validators.required),
        country_code: new FormControl(merchantCountry, Validators.required),
        transfer_mode: new FormControl('', Validators.required),
        fund_source: new FormControl('', Validators.required),
        fund_purpose: new FormControl('', Validators.required),
        relationship: new FormControl('', Validators.required),
        branch_code: new FormControl('', Validators.required),
      }),
      receiver: new FormGroup({
        first_name: new FormControl(nameParts[0] || '', Validators.required),
        last_name: new FormControl(nameParts.slice(1).join(' ') || '', Validators.required),
        address: new FormControl(recipient['address'] || '', Validators.required),
        city: new FormControl(recipient['city'] || '', Validators.required),
        region: new FormControl(recipient['region'] || ''),
        post_code: new FormControl(recipient['post_code'] || ''),
        email: new FormControl(recipient['email'] || ''),
        contact_phone: new FormControl(recipient['contact_phone'] || '', Validators.required),
        country_code: new FormControl(recipient.country_code || '', Validators.required),
      })
    });

    this.ezremitForm.get('initiator.transfer_mode')?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => { if (value) this.onTransferModeChange(value); });

    this.fetchEZremitDropdowns(recipient);
  }

  private fetchEZremitDropdowns = (recipient: any) => {
    const payInCurrency = "USD"
    const payoutCountry = recipient.country_code;
    const payoutCurrency = this.countries.find(c => c.alpha2Code === payoutCountry)?.currencyCode || '';
    const partnerIdentifier = recipient.bank?.bank_code || recipient['bank_code'] || '';

    this.ezremitParams = { payInCurrency, payoutCurrency, payoutCountry, partnerIdentifier };
    this.isLoadingEZremitDropdowns = true;

    this.bulkpayService.getEZremitTransferModeList(payInCurrency, payoutCurrency, payoutCountry, partnerIdentifier)
      .subscribe(
        (res: any) => {
          this.ezremitTransferModes = (res?.data?.data || []).map((item: string) => ({
            code: item,
            name: item
          }));
          this.isLoadingEZremitDropdowns = false;
        },
        _err => { this.isLoadingEZremitDropdowns = false; }
      );

    this.bulkpayService.getEZremitRelationshipList(payInCurrency, payoutCurrency, payoutCountry, partnerIdentifier)
      .subscribe(
        (res: any) => {
          this.ezremitRelationships = (res?.data?.data || []).map((item: any) => ({
            code: item.relationship,
            name: item.relationship
          }));
        },
        _err => { this.toastr.error('Error occurred while fetching EZremit relationships', 'ERROR'); }
      );
  }

  onTransferModeChange = (transferMode: string) => {
    if (!transferMode || !this.ezremitParams) return;
    const { payInCurrency, payoutCurrency, payoutCountry, partnerIdentifier } = this.ezremitParams;

    this.isLoadingTransferModeFields = true;

    this.bulkpayService.getEZremitBranchList(payInCurrency, payoutCurrency, payoutCountry, partnerIdentifier, transferMode)
      .subscribe(
        (res: any) => {
          this.ezremitBranches = (res?.data?.data || res?.data || []).map((item: any) => ({
            code: item.branchCode,
            name: item.branchName
          }));
          this.isLoadingTransferModeFields = false;
        },
        _err => { this.isLoadingTransferModeFields = false; }
      );

    this.bulkpayService.getEZremitFundSourceAndPurpose(payInCurrency, payoutCurrency, payoutCountry, transferMode, partnerIdentifier)
      .subscribe(
        (res: any) => {
          this.ezremitFundSources = (res?.data?.data?.fundSourceList || []).map((item: any) => ({
            code: item.fundSourceCode,
            name: item.fundSource
          }));
          this.ezremitFundPurposes = (res?.data?.data?.purposeList || []).map((item: any) => ({
            code: item.purposeCode,
            name: item.purposeName
          }));
        },
        _err => {
          this.toastr.error('Error occurred while fetching EZremit fund sources and purposes', 'ERROR');
        }
      );
  }

  get ezremitMerchantDialCode(): string {
    const iso2 = this.miscService.getMerchantDetails()?.currency?.iso_code_2 || '';
    return this.countries.find(c => c.alpha2Code === iso2)?.callingCode || '';
  }

  get ezremitRecipientDialCode(): string {
    const recipient: any = this.paymentList?.find((p: any) => ['IN', 'AE', 'CN'].includes(p.country_code));
    return this.countries.find(c => c.alpha2Code === recipient?.country_code)?.callingCode || '';
  }

  normalizeEZremitPhone = (controlPath: string, dialCode: string) => {
    const ctrl = this.ezremitForm.get(controlPath);
    if (!ctrl) return;
    let val = (ctrl.value || '').trim().replace(/^\+/, '');
    if (dialCode && !val.startsWith(dialCode)) {
      val = dialCode + val;
    }
    ctrl.setValue(val, { emitEvent: false });
  }
  // get descriptionRequired(): boolean {
  //   const merchantCurrency = this.miscService.getMerchantDetails()?.currency?.currency_code;
  //   return this.paymentList?.some((p: any) => {
  //     const destCurrency = p.des_currency || this.getCountry(p.country_code);
  //     return destCurrency && destCurrency !== merchantCurrency;
  //   }) || false;
  // }
  get descriptionRequired(): boolean {
    return true;
  }

  proceedWithDlCodes = (retry: boolean) => {
    if (this.hasCDRecipients) {
      this.kycData = this.kycForm.value;
    }
    if (this.hasEZremitRecipients) {
      this.ezremitData = this.ezremitForm.value;
    }
    this.getDlCodes(retry);
  }

    get isLoadingAnyPapssFee(): boolean {
      return Object.values(this.loadingPapssFeesMap).some(v => v);
    }

    fetchPapssFeesForRecipients = () => {
      this.papssFeesMap = {};
      this.loadingPapssFeesMap = {};
      const merchantAlpha2 = this.miscService.getMerchantDetails().currency.iso_code_2;
      this.paymentList.forEach((payee: any, index: number) => {
        if (payee.is_papss && payee.org_no && payee.country_code && payee.amount) {
          this.loadingPapssFeesMap[index] = true;
          this.merchantTransactionsService.getPapssTransferFee(
            merchantAlpha2,
            payee.country_code,
            payee.org_no,
            payee.amount,
            true
          ).subscribe(
            res => {
              this.loadingPapssFeesMap[index] = false;
              if (res.success) {
                this.papssFeesMap[index] = res.data?.fee?.fees?.flat ?? null;
              }
            },
            _err => { this.loadingPapssFeesMap[index] = false; }
          );
        }
      });
    }


  deleteAuthorizer = () => {
    this.isDeleting = true;
    this.transactionService.deleteAuthorizer(this.selectedTransaction.reference_id).subscribe(res => {
      if(res.success) {
        this.toastr.success(res.message, 'SUCCESS');
        this.isDeleting = false;
        this.deleteModalOpen = false;
        this.fetchPendingBulkPayTransactions();
      } else {
        this.toastr.error(res.message, 'ERROR');
        this.isDeleting = false;
      }
    }, err => {
      this.toastr.error(err.error.message, 'ERROR');
      this.isDeleting = false;
    })
  }

  resendAuthorization = (item: any) => {
    this.isSendingAuthorization = true;
    this.selectedTransaction = item;
    const payload = {
      merchant_id: item.merchant_id,
      amount: item.amount,
      description: item.description,
      tranx_id: item.tranx_id,
      payment_id: item.reference_id,
      src_wallet: item.sre_wallet_number,
    }
    this.transactionService.resendAuthorizationEmail(payload).subscribe(res => {
      if(res.success) {
        this.toastr.success(res.message, 'SUCCESS');
        this.isSendingAuthorization = false;
      } else {
        this.toastr.error(res.message, 'ERROR');
        this.isSendingAuthorization = false;
      }
    }, err => {
      this.toastr.error(err.error.message, 'ERROR');
      this.isSendingAuthorization = false;
    })
  }

  toggleDeleteModal = (action: string) => {
    if (action === 'open') {
      this.deleteModalOpen = true;
    } else {
      this.deleteModalOpen = false;
    }
  }
  
    // UNSUBCRIBE FROM OBSERVABLES
    ngOnDestroy(): void {
      this.unsubscribe$.next()
      this.unsubscribe$.complete()
    }

}
